const getCssColors = (cssColor) => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(cssColor)
    .trim();
};

const ExirioStyles = {
  /* New palette defined index.css */
  primaryColorMain:
    getCssColors("--primaryMain") /* Highlighted in selection */,
  background: getCssColors("--background"),
  tableTint: getCssColors("--background"),
  menuHeader: getCssColors("--blue3"),
  modalWindows: getCssColors("--blue4"),
  CTA: getCssColors("--cta"),
  mintMarketing: getCssColors("--accent"),
  orientationNav: getCssColors("--orientation"),
  pureWhiteText: getCssColors("--text"),
  secondaryWhiteText: getCssColors("--text1"),
  errorRed: getCssColors("--error"),
  error: getCssColors("--error"),
  profit: getCssColors("--profit"),
  chartWhite: getCssColors("--chartWhite"),
  chartBlue: getCssColors("--chartBlue"),
  chartGridLine: getCssColors("--chartGridLine"),
};

export default ExirioStyles;
